const DEFAULT_OPTIONS = {
    method: 'GET',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
    credentials: 'same-origin'
};
/**
 * Makes a request to the specified URL. Supports default options plus "json" and "params".
 *
 * @param {string} url - URL.
 * @param {AjaxRequestInfo} options - Options.
 */ export const ajaxRequest = (url, options = {})=>{
    const { json, params, ...rest } = options;
    let completeUrl = url;
    if (params) {
        const qs = new URLSearchParams();
        Object.keys(params).forEach((key)=>{
            qs.append(key, params[key].toString());
        });
        completeUrl += '?' + qs.toString();
    }
    if (json) {
        rest.body = JSON.stringify(json);
    }
    return fetch(completeUrl, {
        ...DEFAULT_OPTIONS,
        ...rest
    });
};
